/**
 * Segmentation Manager
 */

define(function(require, exports, module) {
    'use strict';

    var $ = require('j');
    var Class = require('Class');
    var serverUtil = require('util/server.util');

    module.exports = Class.create({

        initialize: function(user) {
            this.user = user;
        },

        /**
         * Get URL Templates from IMS
         * @param  {Object}  [options]
         * @param  {Boolean} options.silent     prevent the event triggerring for `urlTemplates` parameter
         * @return {Deferred}
         */
        getUrlTemplates: function(options) {
            options = options || {};
            var urlType = Playtech.Variables.userSegmentURLType;
            var state = $.Deferred();

            if (urlType == null || urlType === '') {
                this._storeUrlTemplates([], options);
                return state.resolve();
            }

            serverUtil.getURLsRequest({
                urlTypeList: [urlType]
            }).done(function(response) {
                    var data = this._parseUrlTemplates(response);

                    this._storeUrlTemplates(data, options);
                }.bind(this))
                .always(function() {
                    state.resolve();
                });

            return state;
        },

        _parseUrlTemplates: function(response) {
            if (response == null) {
                return null;
            }

            const urlList = response.data?.urlList;
            // 0 is highest, 10 is lowest
            const highestPriority = urlList
                .map(tmpl => tmpl.priority)
                .reduce((highest, priority) => priority < highest ? priority : highest, Infinity);

            return urlList
                .filter((template) => template.priority <= highestPriority)
                .map(tmpl => tmpl.url);
        },

        _storeUrlTemplates: function(data, options) {
            this.user.set('urlTemplates', data, options);
        }

    });
});
